import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

export interface RecaptchaVerifyResponse {
  success: boolean
  score: number
  'error-codes': string[]
  challenge_ts: string
  hostname: string
}

@Injectable()
export class RecaptchaService {
  constructor(private http: HttpClient) {}

  verify(token: string) {
    return this.http.get<RecaptchaVerifyResponse>(`@api/validate/recaptcha?value=${token}`)
  }

  isRobot(res: RecaptchaVerifyResponse) {
    if (!res.success) {
      throw new Error(res['error-codes'].join(', '))
    }
    return res.score <= 0.4
  }
}
